"use client";

import { c as _c } from "react/compiler-runtime";
import { env } from "~/setup/env";
import { useLanguage } from "~/translations/loader/use-language";
export default function IntroEonSverige() {
  const $ = _c(8);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundImage: `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobad/company-bg.png)`,
      backgroundSize: "cover",
      backgroundPosition: "right"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.sverige_intro_HL) {
    t1 = <h2 className="mb-10 hidden font-bold text-4xl md:text-5xl print:text-lg" data-source="lc">{t.sverige_intro_HL}</h2>;
    $[1] = t.sverige_intro_HL;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t.sverige_intro_text) {
    t2 = <div className="max-w-screen-md text-lg" dangerouslySetInnerHTML={{
      __html: t.sverige_intro_text
    }} data-source="lc" />;
    $[3] = t.sverige_intro_text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <section className="outer-container py-container text-white" id="intro" style={t0}><div className="inner-container"><div className="grid gap-8 lg:auto-cols-fr lg:grid-flow-col xl:gap-12"><div className="my-auto">{t1}{t2}</div></div></div></section>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}